import { useTranslation } from "react-i18next";
import { CheckCircle2, LogIn, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export default function CanceledPage() {
  const { t } = useTranslation(["auth"]);
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="text-center pb-4">
          <div className="flex justify-center mb-3">
            <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center">
              <CheckCircle2 className="w-7 h-7 text-muted-foreground" />
            </div>
          </div>
          <CardTitle className="text-xl" data-testid="text-canceled-title">{t("auth:canceled.title")}</CardTitle>
          <CardDescription className="text-sm mt-1">
            {t("auth:canceled.desc")}
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="rounded-lg bg-muted/50 border px-4 py-3 text-sm text-muted-foreground" data-testid="text-canceled-message">
            <p>{t("auth:canceled.message")}</p>
          </div>

          <Button
            className="w-full gap-2"
            onClick={() => { window.location.href = "/login?resubscribe=1"; }}
            data-testid="button-resubscribe"
          >
            <RotateCcw className="w-4 h-4" />
            {t("auth:canceled.resubscribe")}
          </Button>

          <Button
            variant="ghost"
            className="w-full gap-2 text-muted-foreground"
            onClick={() => { window.location.href = "/login"; }}
            data-testid="button-back-to-login"
          >
            <LogIn className="w-4 h-4" />
            {t("auth:canceled.backToLogin")}
          </Button>

          <p className="text-xs text-center text-muted-foreground">
            {t("auth:canceled.questions")}{" "}
            <a href="mailto:support@dealermind.ai" className="underline underline-offset-2">
              support@dealermind.ai
            </a>.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
